import type { FC } from "react";

import { InteractionModeIcon } from "./InteractionModeIcon";

import { showPageDisabled } from "components/materials/page/groups/helpers";
import { InteractionMode, PageType } from "components/server-types";

export const IconFromPage: FC<{
  page: Pick<PageType, "interaction_mode" | "released_at" | "category">;
  isSelected?: boolean;
  isInTemplateSection?: boolean;
}> = ({ page, isSelected, isInTemplateSection }) => {
  if (page.interaction_mode === InteractionMode.STATIC) {
    return null;
  }

  const isDisabled = showPageDisabled(page) && !isInTemplateSection;
  const variant = isSelected ? "selected" : isDisabled ? "disabled" : "default";

  return <InteractionModeIcon interactionMode={page.interaction_mode} variant={variant} />;
};
